import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LingValidators {
  static sameAs(
    targetFormControlPath: string,
    errorName: string = targetFormControlPath
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const targetControlValue = control.root.get(targetFormControlPath)?.value;

      if (!value || !targetControlValue) {
        return null;
      }

      return control.value !== targetControlValue
        ? {
            sameAs: {
              targetControlName: errorName,
              value,
              targetValue: targetControlValue,
            },
          }
        : null;
    };
  }

  static minArrayLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      return control.value.length < length
        ? {
            minArrayLength: {
              requiredLength: length,
              actualLength: control.value.length,
            },
          }
        : null;
    };
  }

  static maxArrayLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      return control.value.length > length
        ? {
            maxArrayLength: {
              requiredLength: length,
              actualLength: control.value.length,
            },
          }
        : null;
    };
  }

  static minNumberLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      return String(control.value).length < length
        ? {
            minNumberLength: {
              requiredLength: length,
              actualLength: String(control.value).length,
            },
          }
        : null;
    };
  }

  static maxNumberLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      return String(control.value).length < length
        ? {
            maxNumberLength: {
              requiredLength: length,
              actualLength: String(control.value).length,
            },
          }
        : null;
    };
  }

  static compareTo(
    targetFormControlPath: string,
    predicate: (currentValue?: any, comparedValue?: any) => boolean,
    errorMessage: string
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const targetControlValue = control.root.get(targetFormControlPath)?.value;

      if (!value || !targetControlValue) {
        return null;
      }

      return !predicate(value, targetControlValue)
        ? {
            compareTo: {
              targetControlName: targetFormControlPath,
              errorMessage,
              value,
              targetValue: targetControlValue,
            },
          }
        : null;
    };
  }
}
